module.exports = __webpack_public_path__ + "img/gartek-services-electrical-safety-sensitivity.b0c6fc5d.png";